import React from 'react';
import { connect } from 'redux-bundler-react';

class LabelToggle extends React.Component {
  constructor(props){
    super(props);
    this.toggleLabels = this.toggleLabels.bind(this);
  }

  toggleLabels(e){
    const { layer, doLayerSetLabels } = this.props;
    doLayerSetLabels(layer.uid, !layer.labelsOn);
  }

  render(){
    const { layer } = this.props;
    const { labelsOn } = layer;
    if(!layer.labelEnabled) return null;
    return (
      <div>
        <hr/>
        <div>
          <div className="checkbox">
            <label>
              <input checked={labelsOn} onChange={this.toggleLabels} type="checkbox" />Label Features
            </label>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  'selectAppTime',
  'doLayerSetLabels',
  LabelToggle
);